import React from 'react';
import { useParams } from "react-router-dom";
import FriscoAuditLogging from './FriscoAuditLogging';

export default (props) => {
    let { id } = useParams();
    let { pid } = useParams();
    
    return <FriscoAuditLogging id={id} pid={pid} />;
}
